export const enterpriseEditionUrl = 'https://www.openproject.org/enterprise-edition/?op_edition=community-edition';

export const contactUrl:{ [locale:string]:string } = {
  en: 'https://www.openproject.org/contact/',
  de: 'https://www.openproject.org/de/kontakt/',
};

export const pricingUrl = 'https://www.openproject.org/pricing';

export const enterpriseDocsUrl:{ [key:string]:string } = {
  website: 'https://www.openproject.org/enterprise-edition/',
  boards: 'https://www.openproject.org/docs/user-guide/agile-boards/#action-boards-premium-feature',
  tableHighlighting: 'https://www.openproject.org/docs/user-guide/work-packages/work-package-table-configuration/#attribute-highlighting-premium-feature',
  graphWidgets: 'https://www.openproject.org/docs/user-guide/project-overview/#work-package-graph-widgets-premium-feature',
};
